import { Create, useCreate, useNotify, useRedirect } from 'react-admin';
import BillerMerchantCodeForm from './BillerMerchantCodeForm';

const BillerMerchantCodeCreate = () => {
  const [create] = useCreate();
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSave = (data: any) => {
    return new Promise((resolve, reject) => {
      create(
        'billerMerchantCodes',
        { data },
        {
          onSuccess: (response) => {
            notify('Merchant code created successfully', { type: 'success' });
            redirect('list', 'billerMerchantCodes');
            resolve(response);
          },
          onError: (error: any) => {
            notify(error?.message || 'Error creating merchant code', {
              type: 'error',
            });
            reject(error);
          },
        }
      );
    });
  };

  return (
    <Create>
      <BillerMerchantCodeForm onSubmit={handleSave} />
    </Create>
  );
};

export default BillerMerchantCodeCreate;
